import stringify from 'json-stable-stringify';
import { ApiRequestParams } from './apiRequestParams';

/**
 * Identity fields that `executeMakeRequest` may send as headers and that must
 * be part of the in-flight GET/HEAD dedupe key so concurrent callers cannot
 * share a response across impersonation / integration-auth / language changes.
 */
export type RequestIdentitySnapshot = {
  impersonatedUserId: string | null;
  language: string | null;
  integrationUserId: string | null;
  integrationEmail: string | null;
};

/**
 * Builds a stable in-flight dedupe key for an endpoint + params/body + identity.
 * @param endpointName - EndpointDefinition.name
 * @param params - Route/query params (or undefined)
 * @param body - Request body (or undefined)
 * @param identity - Identity headers snapshot (must match headers for this call)
 * @returns Key used by dedupeRequest
 */
export function buildRequestDedupeKey(
  endpointName: string,
  params: ApiRequestParams | undefined,
  body: object | undefined,
  identity: RequestIdentitySnapshot
): string {
  return `${endpointName}-${stringify({
    params: params ?? null,
    body: body ?? null,
    identity,
  })}`;
}
